import { getAuthMe } from 'common/api/v1/auth';
import { updateSession } from 'common/utils/helpers/session';

import { FETCH, FETCH_FAILURE, FETCH_SUCCESS } from '../actionTypes';
import { profileActions } from '../reducer';

import initializeForm from './initializeForm';
import initializeMultiregion from './initializeMultiregion';
import setCurrentValues from './setCurrentValues';

export default () => (dispatch) => {
    dispatch(profileActions[FETCH]());

    getAuthMe()
        .then((response) => {
            dispatch(profileActions[FETCH_SUCCESS](response?.data?.data));

            dispatch(initializeForm(response?.data?.data));
            dispatch(initializeMultiregion(response?.data?.data));
            dispatch(
                setCurrentValues({
                    first_name: response?.data?.data?.first_name,
                    last_name: response?.data?.data?.last_name,
                    profile_image: response?.data?.data?.profile_image,
                    main_branch_office:
                        response?.data?.data?.main_branch_office,
                }),
            );
            updateSession({
                settings: response?.data?.data?.settings,
            });
        })
        .catch((error) =>
            dispatch(
                profileActions[FETCH_FAILURE](error?.response?.data?.errors),
            ),
        );
};
